import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { LineVortexTutorialState } from './LineTutorialAdapter.js';

type VState = LineVortexTutorialState;

const PARTIAL = '04,0414,1424,2425,2232,3233,3334,4142,3435,4252,3545,5253';
const PARTIAL_1GATE = `${PARTIAL}|B4=C2`;
const PARTIAL_GATED = `${PARTIAL}|B4=C2,D4=E1`;
const SOLVED = '04,0414,1424,2425,2232,3233,3334,3435,0313,1213,1112,1121,2131,3031,4142,4252,3545,5253,5363|B4=C2,D4=E1';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { line: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'D0', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'C5', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { line: PARTIAL },
                { line: PARTIAL, gateMode: true },
                { line: PARTIAL_1GATE, gateMode: true },
                { line: PARTIAL_GATED, gateMode: true },
                { line: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle the pair active (line pieces never block a gate)
    {
        gameState: { line: '', gateMode: true } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'C3', anchor: 'center', color: COLORS.teal },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { line: '', gateMode: true },
                { line: '|B4=C2', gateMode: true },
            ] as VState[],
        },
    },

    // Scene 3: Line teleportation
    {
        gameState: { line: PARTIAL_GATED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Line corners jump\nthrough a gate...', cell: 'B5', anchor: 'center' },
            { type: 'text-label', text: '...and exit from\nthe other side', cell: 'C2', anchor: 'far-right' },
            { type: 'pulse', cell: 'B4', color: COLORS.purple },
            { type: 'pulse', cell: 'C2', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state — segment mirroring hint
    {
        gameState: { line: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Segments are mirrored\nacross gate pairs', cell: 'D0', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'B4', color: COLORS.purple },
            { type: 'pulse', cell: 'C2', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Line tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches line teleportation and segment mirroring through Vortex gates.
 */
export const LINE_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'line-vortex',
    gridCode: '6/0-3:0C4,1F2,2A3,3D1',
    scenes,
    previewScene: 3,
};
